import { render, staticRenderFns } from "./BuyerCampaigns.vue?vue&type=template&id=1bb7d1a0"
import script from "./BuyerCampaigns.vue?vue&type=script&lang=js"
export * from "./BuyerCampaigns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports